import { Link } from "react-router-dom";

function ClosingTfLanding() {
  return (
    <section className="closing-tf-landing">
      {/* Column 1: Image */}
      <div className="closing-tf-image">
        <img
          src={`${process.env.PUBLIC_URL}/images/tf_closing_image.png`}
          alt="Get Started"
        />
      </div>

      {/* Column 2: Title and CTAs */}
      <div className="closing-tf-content">
        <div className="closing-tf-title-container">
          <h2 className="white-heading closing-tf-title">Clear Pricing</h2>
          <h2 className="white-heading closing-tf-title">Certified Pros</h2>
          <h2 className="white-heading closing-tf-title">
            You stay in control
          </h2>
        </div>

        <div className="closing-tf-cta-container">
          <Link to="/sign-up" className="cta-button primary_light">
            Create Your Account
          </Link>
          <Link to="/sign-in" className="cta-button secondary">
            Sign In
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ClosingTfLanding;
